import mongoose from 'mongoose';

const connect = () => {
    try {
        let host = process.env.SERVER_HOST;
        let protocol = 'mongodb://';
        if (host.startsWith('domain:')) {
            protocol = 'mongodb+srv://';
            host = host.replace('domain:', '');
        }
        mongoose.set('strictQuery', false);
        return mongoose.connect(
            `${protocol}${process.env.DB_FRONT_LOGIN}:${process.env.DB_FRONT_PASSWORD}@${host}/${process.env.DATABASE}`
        );
    } catch (error) {
        return {};
    }
};
export default connect;
